export class EnglishProficiencyDetails {
    TestTypeCode: string;
    HasTakenTest: boolean;
    DateTaken: string;
    ListeningScore: number;
    ReadingScore: number;
    WritingScore: number;
    SpeakingScore: number;
    VocabularyScore: number;
    TotalScore: number;
    OtherTestName: string;
    AllSubjectsTaughtInEnglish: boolean;
    SpeaksEnglishAtHome: boolean;
}
